import { eduIDApi } from "./common";
export const orcidApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchOrcid: builder.query({
            query: () => ({
                url: "",
            }),
            extraOptions: { service: "orcid" },
        }),
        removeOrcid: builder.query({
            query: () => ({
                url: "remove",
                body: {},
            }),
            extraOptions: { service: "orcid" },
        }),
        connectOrcid: builder.query({
            query: () => ({
                url: "connect-orcid",
                body: {
                    frontend_action: "connectOrcid",
                    frontend_state: "optional-opaque-string",
                },
            }),
            extraOptions: { service: "orcid" },
        }),
        orcidGetStatus: builder.query({
            query: (body) => ({
                url: "get-status",
                body,
            }),
            extraOptions: { service: "orcid" },
        }),
    }),
});
